
// src/services/axiosInstance.js
import axios from 'axios';



const configFile = await fetch('/config.json');
const fileConfig = await configFile.json();
const baseURL = fileConfig.API_BASE_URL;
const axiosInstance = axios.create({

    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000,
});


export default axiosInstance;
